export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/event_videos.9dedae6.svg";